function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13 4H6.5A2.5 2.5 0 004 6.5V13a2 2 0 01-2-2V4a2 2 0 012-2h7a2 2 0 012 2zM7 5h7a2 2 0 012 2v7a2 2 0 01-2 2H7a2 2 0 01-2-2V7a2 2 0 012-2zm.5 2a.5.5 0 000 1h6a.5.5 0 100-1h-6zm0 2a.5.5 0 000 1h4a.5.5 0 100-1h-4zm0 2a.5.5 0 100 1h2a.5.5 0 100-1h-2z",
  fillRule: "evenodd"
});

var SvgClone = function SvgClone(props) {
  return React.createElement("svg", _extends({
    width: 18,
    viewBox: "0 0 18 18"
  }, props), _ref);
};

export default SvgClone;